var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wizzard-holder"},[_c('ul',{staticClass:"wizzard"},[_c('li',{staticClass:"wizzard-item active"},[_c('div',{staticClass:"item-line"})]),_c('li',{staticClass:"wizzard-item"},[_c('div',{staticClass:"item-line"})])])])
}]

export { render, staticRenderFns }